import styles from "../../styles/Components/mini-app/MiniAppContainer.module.css";
import MiniNavbar from "./layout/MiniNavbar";

function MiniAppContainer({ children }) {
  return (
    <div className={styles.container}>
      <main className={styles.main}>{children}</main>
      <MiniNavbar />
    </div>
  );
}

export default MiniAppContainer;
